module.exports = {
	"data": {
		"site": {
			"siteMetadata": {
				"title": "Nate A Taylor",
				"author": "Nate A Taylor",
				"description": "Website of Nate A Taylor"
			}
		},
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"fields": {
							"slug": "/posts/2017/08/02/building-a-blog-with-gatsby-pt-2/"
						},
						"frontmatter": {
							"title": "Building a Blog with Gatsby Pt 2",
							"summary": "Setup Gatsby to automatically turn markdown files into blog posts.",
							"date": "August 02, 2017"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/posts/2017/07/21/building-a-blog-with-gatsby-pt-1/"
						},
						"frontmatter": {
							"title": "Building a Blog with Gatsby Pt 1",
							"summary": "How to build a personal site with Gatsby.",
							"date": "July 21, 2017"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/posts/2017/07/18/welcome/"
						},
						"frontmatter": {
							"title": "Welcome",
							"summary": "An introduction to me.",
							"date": "July 18, 2017"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/posts.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/posts.json
// module chunks = 140933230050240